import { file } from '@/api'

import { FILE_IMAGE_ADD, FILE_IMAGE_ADD_ERROR } from './types'

const addImage = async (ctx, image) => {
	try {
		const { data } = await file.addImage(image)
		const imageData = data?.data
		ctx.commit(FILE_IMAGE_ADD, imageData)
	} catch (e) {
		ctx.commit(FILE_IMAGE_ADD_ERROR, e)
		throw e
	}
}

export default {
	addImage,
}
